module.exports = __webpack_public_path__ + "static/media/hedo,_jamaica.90fac391.png";